import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "component-title fw-bold small border-bottom pb-2 mb-3" };
const _hoisted_2 = {
    key: 0,
    class: "accordion accordion-flush",
    id: "lidSelectionAccordion"
};
const _hoisted_3 = { class: "accordion-item" };
const _hoisted_4 = { class: "accordion-header" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "accordion-body px-0" };
const _hoisted_8 = {
    key: 0,
    class: "row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3"
};
const _hoisted_9 = { class: "col position-relative" };
const _hoisted_10 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_11 = { class: "text-center fw-bold" };
const _hoisted_12 = { class: "text-center" };
const _hoisted_13 = { class: "col position-relative" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
    class: "w-100 d-flex justify-content-center align-items-center",
    style: { "height": "100px" }
};
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_18 = { class: "text-center fw-bold" };
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
    key: 0,
    class: "accordion-item"
};
const _hoisted_22 = { class: "accordion-header" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 1 };
const _hoisted_25 = { class: "accordion-body px-0" };
const _hoisted_26 = { class: "row row-cols-6 mt-3" };
const _hoisted_27 = { class: "col position-relative" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_30 = { class: "text-center fw-bold" };
const _hoisted_31 = {
    key: 1,
    class: "accordion-item"
};
const _hoisted_32 = { class: "accordion-header" };
const _hoisted_33 = {
    class: "accordion-button",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#lidVariantComponentSelection"
};
const _hoisted_34 = {
    id: "lidVariantComponentSelection",
    class: "accordion-collapse collapse show",
    "data-bs-parent": "#lidSelectionAccordion"
};
const _hoisted_35 = { class: "accordion-body" };
const _hoisted_36 = { class: "row row-cols-1 row-cols-md-4 row-cols-xl-6 mt-3" };
const _hoisted_37 = { class: "col position-relative border-end" };
const _hoisted_38 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_39 = { class: "text-center fw-bold" };
const _hoisted_40 = {
    class: "w-100 d-flex justify-content-center align-items-center my-3",
    style: { "height": "100px" }
};
const _hoisted_41 = ["src"];
const _hoisted_42 = {
    key: 0,
    class: "text-center mt-2"
};
const _hoisted_43 = { class: "small fw-bold mb-1" };
const _hoisted_44 = ["id"];
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
    key: 1,
    class: "form-check form-switch w-100 d-flex justify-content-center align-items-center mt-2",
    style: { "height": "40px" }
};
const _hoisted_47 = ["checked", "onChange"];
const _hoisted_48 = { class: "col-12 col-lg-6 d-flex align-items-center justify-content-center mb-4 mb-lg-0" };
const _hoisted_49 = { class: "shadow rounded rounded-2 p-3" };
const _hoisted_50 = { class: "fw-bold mb-4" };
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { class: "table bg-transparent" };
const _hoisted_53 = { key: 0 };
const _hoisted_54 = {
    class: "bg-transparent",
    scope: "row"
};
const _hoisted_55 = { class: "bg-transparent" };
const _hoisted_56 = { key: 1 };
const _hoisted_57 = {
    class: "bg-transparent",
    scope: "row"
};
const _hoisted_58 = { class: "bg-transparent" };
const _hoisted_59 = { key: 2 };
const _hoisted_60 = {
    class: "bg-transparent",
    scope: "row"
};
const _hoisted_61 = { class: "bg-transparent" };
const _hoisted_62 = {
    key: 0,
    class: "d-flex align-items-center"
};
const _hoisted_63 = { class: "col-12 col-lg-6 d-flex justify-content-center" };
const _hoisted_64 = {
    key: 2,
    class: "d-flex justify-content-center align-items-center flex-column"
};
const _hoisted_65 = { class: "fw-bold text-primary" };
const _hoisted_66 = {
    key: 0,
    id: "contextModal"
};
const _hoisted_67 = { class: "d-block d-md-flex justify-content-between align-items-center mb-3" };
const _hoisted_68 = { class: "fw-bold mb-3 gallery-font-color" };
const _hoisted_69 = ["innerHTML"];
const _hoisted_70 = { class: "d-flex justify-content-center" };
const _hoisted_71 = { class: "ms-4" };
const _hoisted_72 = ["src"];
import { standardFunctions } from '@/Configurator/Composables/standardFunctions';
import axios from 'axios';
import Swal from 'sweetalert2';
import { onMounted, ref, watch } from 'vue';
import PreviewContainer from '../Shared/PreviewContainer.vue';
import { formatters } from '@/Composables/formatters';
import ContextModal from './ContextModal.vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LidSelection',
    props: {
        configurationId: String,
        tenantId: String,
        bottle: Object,
    },
    emits: ['update', 'noAvailableLidsForSelectedBottle'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        let { mmToPx } = standardFunctions();
        let { formatCurrency } = formatters();
        let { showErrorSwal } = responseMessages();
        const props = __props;
        const emit = __emit;
        const bottlePreviewKey = ref(null);
        // PREVIEW
        const scaleFactor = ref(8); //Scale Faktor?
        // PREVIEW END
        const searchString = ref('');
        const loading = ref(false);
        const lids = ref([]);
        const detailsLid = ref(null);
        const modal = ref();
        const selectedLid = ref(null);
        const selectedLidVariant = ref(null);
        const selectedComponents = ref([]);
        onMounted(() => {
            if (props.bottle == null) {
                return;
            }
            loadSavedSelection();
        });
        watch(searchString, () => {
            search();
        });
        function loadSavedSelection() {
            axios.post(route('configurator.lids.selection.load', props.configurationId), {})
                .then(function (response) {
                if (response.data != null && response.data != '') {
                    selectedLid.value = response.data.lid;
                    selectedLidVariant.value = response.data.lidVariant;
                    selectedComponents.value = response.data.components;
                    emit('update', selectedLid.value, selectedLidVariant.value);
                }
                search();
                if (selectedLid.value) {
                    setTimeout(() => {
                        bottlePreviewKey.value = Math.random().toString(36).substring(7);
                    }, 1000);
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function search() {
            axios.post(route('configurator.lids.selection.index'), {
                tenantId: props.tenantId,
                bottleId: props.bottle?.id,
                searchString: searchString.value,
            })
                .then(function (response) {
                lids.value = response.data;
                if (lids.value.length == 0) {
                    emit('noAvailableLidsForSelectedBottle');
                }
                if (selectedLid.value) {
                    const selectedLidIndex = lids.value.findIndex(lid => lid.id === selectedLid.value?.id);
                    if (selectedLidIndex === -1) {
                        lids.value.unshift(selectedLid.value);
                    }
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function showLidDetails(lid, event) {
            axios.post(route('configurator.lids.selection.details.show', lid.id), {})
                .then(function (response) {
                detailsLid.value = response.data;
                modal.value.openAt(event.clientX, event.clientY);
            })
                .catch(function (error) {
                console.log(error);
                detailsLid.value = null;
            });
        }
        function selectLid(lid, forceChange = false) {
            bottlePreviewKey.value = null;
            if (lid && selectedLid.value && selectedLid.value.id != lid.id && !forceChange) {
                Swal.fire({
                    title: t('Möchten Sie wirklich einen anderen Verschluss wählen?'),
                    text: t('Durch die Änderung gehen alle bereits durchgeführten nachfolgendenen Konfigurationen verloren.'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: t("Mit neuer Auswahl fortfahren"),
                    cancelButtonText: t("Auswahl beibehalten"),
                    confirmButtonColor: "#528399",
                    cancelButtonColor: "#dc3545",
                }).then((result) => {
                    if (result.isConfirmed) {
                        selectLid(lid, true);
                    }
                });
                return;
            }
            selectedLidVariant.value = null;
            saveLidSelection(lid, null);
        }
        function selectVariant(lidVariant) {
            if (selectedLid.value == null || lidVariant == null) {
                return;
            }
            selectedLidVariant.value = lidVariant;
            saveLidSelection(selectedLid.value, lidVariant);
        }
        function selectComponentColor(component, color) {
            const componentIndex = selectedComponents.value.findIndex(c => c.id === component.id);
            if (componentIndex != -1) {
                selectedComponents.value[componentIndex].colorId = color.id;
                selectedComponents.value[componentIndex].hexColor = color.hex;
            }
            else {
                selectedComponents.value.push({ id: component.id, colorId: color.id, hexColor: color.hex, image: component.image, showPreview: component.showPreview, width: component.width, topDistance: component.topDistance });
            }
            updateSelectedComponents();
        }
        function toggleComponent(component) {
            const componentIndex = selectedComponents.value.findIndex(c => c.id === component.id);
            if (componentIndex != -1) {
                selectedComponents.value.splice(componentIndex, 1);
            }
            else {
                let colorId = component.colors.length > 0 ? component.colors[0].id : null;
                selectedComponents.value.push({ id: component.id, colorId: colorId, image: component.image, showPreview: component.showPreview, width: component.width, topDistance: component.topDistance });
            }
            updateSelectedComponents();
        }
        function isComponentSelected(componentId) {
            return selectedComponents.value.find(c => c.id === componentId) != null;
        }
        function getSelectedComponentHexColor(componentId, availableColors) {
            const selectedComponent = selectedComponents.value.find(c => c.id === componentId);
            if (selectedComponent) {
                const selectedColor = availableColors.find(color => color.id === selectedComponent.colorId);
                if (selectedColor) {
                    return selectedColor.hex;
                }
            }
            return availableColors[0].hex;
        }
        function saveLidSelection(lid, lidVariant) {
            axios.post(route('configurator.lids.selection.store', props.configurationId), {
                lidId: lid?.id,
                lidVariantId: lidVariant?.id,
            })
                .then(function (response) {
                selectedLid.value = lid;
                loadSavedSelection();
                if (lid == null) {
                    emit('update', null, null);
                }
            })
                .catch(function (error) {
                console.log(error);
                showErrorSwal(error.response?.data || t('Fehler, bitte versuchen Sie es erneut.'));
            });
        }
        function updateSelectedComponents() {
            axios.post(route('configurator.lids.components.selection.update', props.configurationId), {
                selectedComponents: JSON.parse(JSON.stringify(selectedComponents.value)),
            })
                .then(function () {
                bottlePreviewKey.value = Math.random().toString(36).substring(7);
                emit('update', selectedLid.value, selectedLidVariant.value);
            })
                .catch(function (error) {
                console.log(error);
                showErrorSwal(error.response?.data || t('Fehler, bitte versuchen Sie es erneut.'));
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(t)('Verschluss-Auswahl')), 1),
                (!loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["accordion-button", { collapsed: selectedLid.value != null }]),
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#lidSelection"
                                }, [
                                    (selectedLid.value == null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('Wählen Sie Ihren Verschluss')), 1))
                                        : _createCommentVNode("", true),
                                    (selectedLid.value != null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                            _createTextVNode(_toDisplayString(_unref(t)('Gewählter Verschluss')) + ": ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(selectedLid.value.name), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 2)
                            ]),
                            _createElementVNode("div", {
                                id: "lidSelection",
                                class: _normalizeClass(["accordion-collapse", { collapse: selectedLid.value != null }]),
                                "data-bs-parent": "#lidSelectionAccordion"
                            }, [
                                _createElementVNode("div", _hoisted_7, [
                                    (!loading.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("button", {
                                                    class: _normalizeClass(["btn bg-light border border-2 rounded-3 p-0 w-100", { 'border border-5 border-success': selectedLid.value == null }]),
                                                    style: { "overflow": "hidden" },
                                                    onClick: _cache[0] || (_cache[0] = ($event) => (selectLid(null)))
                                                }, [
                                                    _cache[1] || (_cache[1] = _createElementVNode("div", {
                                                        class: "w-100 d-flex justify-content-center align-items-center",
                                                        style: { "height": "100px" }
                                                    }, [
                                                        _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            height: "100",
                                                            fill: "currentColor",
                                                            class: "bi bi-x",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_10, [
                                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('ohne Verschluss')), 1),
                                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(formatCurrency)(0)), 1)
                                                    ])
                                                ], 2)
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lids.value, (lid) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["btn bg-light border border-2 rounded-3 p-0 w-100", { 'border border-5 border-success': selectedLid.value != null && selectedLid.value.id == lid.id }]),
                                                        style: { "overflow": "hidden" },
                                                        onClick: ($event) => (selectLid(lid))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_15, [
                                                            _createElementVNode("img", {
                                                                src: lid.image,
                                                                class: "h-75"
                                                            }, null, 8, _hoisted_16)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_17, [
                                                            _createElementVNode("span", _hoisted_18, _toDisplayString(lid.name), 1),
                                                            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('ab')) + " " + _toDisplayString(_unref(formatCurrency)(lid.startPrice)), 1)
                                                        ])
                                                    ], 10, _hoisted_14),
                                                    _createElementVNode("button", {
                                                        class: "btn position-absolute end-0 top-0 mt-2 me-3",
                                                        onClick: ($event) => (showLidDetails(lid, $event))
                                                    }, [...(_cache[2] || (_cache[2] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                height: "30",
                                                                fill: "currentColor",
                                                                class: "bi bi-info-circle-fill text-secondary",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
                                                            ], -1)
                                                        ]))], 8, _hoisted_20)
                                                ]));
                                            }), 256))
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ], 2)
                        ]),
                        (selectedLid.value && selectedLid.value.variants.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("h2", _hoisted_22, [
                                    _createElementVNode("button", {
                                        class: _normalizeClass(["accordion-button", { collapsed: selectedLidVariant.value != null }]),
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#lidVariantSelection"
                                    }, [
                                        (selectedLidVariant.value == null)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)('Wählen Sie Ihre Variante')), 1))
                                            : _createCommentVNode("", true),
                                        (selectedLidVariant.value != null)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                                _createTextVNode(_toDisplayString(_unref(t)('Gewählte Variante')) + ": ", 1),
                                                _createElementVNode("strong", null, _toDisplayString(selectedLidVariant.value.name), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 2)
                                ]),
                                _createElementVNode("div", {
                                    id: "lidVariantSelection",
                                    class: _normalizeClass(["accordion-collapse", { collapse: selectedLidVariant.value != null }]),
                                    "data-bs-parent": "#lidSelectionAccordion"
                                }, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLid.value.variants, (variant) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["btn bg-light border border-2 rounded-3 p-0 w-100", { 'border border-5 border-success': selectedLidVariant.value != null && selectedLidVariant.value.id == variant.id }]),
                                                        style: { "overflow": "hidden" },
                                                        onClick: ($event) => (selectVariant(variant))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_29, [
                                                            _createElementVNode("span", _hoisted_30, _toDisplayString(variant.name), 1)
                                                        ])
                                                    ], 10, _hoisted_28)
                                                ]));
                                            }), 256))
                                        ])
                                    ])
                                ], 2)
                            ]))
                            : _createCommentVNode("", true),
                        (selectedLidVariant.value && selectedLidVariant.value.components.length > 0 && (selectedLidVariant.value.components.length > 1 || selectedLidVariant.value.components[0].isOptional))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("h2", _hoisted_32, [
                                    _createElementVNode("button", _hoisted_33, _toDisplayString(_unref(t)('Wählen Sie Ihre Komponenten & Farbanpassungen')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLidVariant.value.components, (component) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                    _createElementVNode("div", _hoisted_38, [
                                                        _createElementVNode("span", _hoisted_39, _toDisplayString(component.name), 1),
                                                        _createElementVNode("div", _hoisted_40, [
                                                            _createElementVNode("img", {
                                                                src: component.image,
                                                                class: "h-50",
                                                                style: { "max-width": "50%" }
                                                            }, null, 8, _hoisted_41)
                                                        ]),
                                                        (component.colors.length > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                                _createElementVNode("p", _hoisted_43, _toDisplayString(_unref(t)('Farbauswahl')), 1),
                                                                _createElementVNode("div", {
                                                                    class: "border border-2 rounded-circle d-inline-block",
                                                                    style: _normalizeStyle([{ "width": "40px", "height": "40px", "cursor": "pointer" }, { backgroundColor: getSelectedComponentHexColor(component.id, component.colors) }])
                                                                }, null, 4),
                                                                _createElementVNode("div", {
                                                                    class: "mt-2",
                                                                    id: 'colors-' + component.id
                                                                }, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.colors, (color) => {
                                                                        return (_openBlock(), _createElementBlock("button", {
                                                                            class: "btn rounded-circle border border-2 m-1",
                                                                            style: _normalizeStyle([{ backgroundColor: color.hex }, { "width": "30px", "height": "30px", "cursor": "pointer" }]),
                                                                            onClick: ($event) => (selectComponentColor(component, color))
                                                                        }, null, 12, _hoisted_45));
                                                                    }), 256))
                                                                ], 8, _hoisted_44)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (component.isOptional)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                                _createElementVNode("input", {
                                                                    class: "form-check-input",
                                                                    type: "checkbox",
                                                                    role: "switch",
                                                                    style: { "width": "2.7rem", "height": "1.5rem" },
                                                                    checked: isComponentSelected(component.id),
                                                                    onChange: ($event) => (toggleComponent(component))
                                                                }, null, 40, _hoisted_47)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]));
                                            }), 256))
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (!loading.value && props.bottle && selectedLid.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "row mt-5",
                        style: _normalizeStyle({ height: (_unref(mmToPx)(props.bottle.height) + _unref(mmToPx)(selectedLid.value.height)) / scaleFactor.value + 'px' })
                    }, [
                        _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("h5", _hoisted_50, [
                                    _createTextVNode(_toDisplayString(_unref(t)('Ihre Zusammenstellung')) + " - ", 1),
                                    (props.bottle)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(props.bottle.name), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("table", _hoisted_52, [
                                    _createElementVNode("tbody", null, [
                                        (selectedLid.value)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                                                _createElementVNode("th", _hoisted_54, _toDisplayString(_unref(t)('Verschluss')), 1),
                                                _createElementVNode("td", _hoisted_55, _toDisplayString(selectedLid.value.name), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (selectedLidVariant.value)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                                                _createElementVNode("th", _hoisted_57, _toDisplayString(_unref(t)('Variante')), 1),
                                                _createElementVNode("td", _hoisted_58, _toDisplayString(selectedLidVariant.value.name), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (selectedLidVariant.value)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_59, [
                                                _createElementVNode("th", _hoisted_60, _toDisplayString(_unref(t)('Bestandteile')), 1),
                                                _createElementVNode("td", _hoisted_61, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLidVariant.value.components, (component, index) => {
                                                        return (_openBlock(), _createElementBlock("div", null, [
                                                            (isComponentSelected(component.id))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                                    (component.colors.length > 0)
                                                                        ? (_openBlock(), _createElementBlock("div", {
                                                                            key: 0,
                                                                            class: "border border-2 rounded-circle d-inline-block me-3",
                                                                            style: _normalizeStyle([{ "width": "20px", "height": "20px" }, { backgroundColor: getSelectedComponentHexColor(component.id, component.colors) }])
                                                                        }, null, 4))
                                                                        : _createCommentVNode("", true),
                                                                    _createTextVNode(" " + _toDisplayString(component.name), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]));
                                                    }), 256))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                            (bottlePreviewKey.value && bottlePreviewKey.value != '')
                                ? (_openBlock(), _createBlock(PreviewContainer, {
                                    configurationId: __props.configurationId,
                                    tenantId: __props.tenantId,
                                    bottle: props.bottle,
                                    previewHeight: 500,
                                    key: bottlePreviewKey.value
                                }, null, 8, ["configurationId", "tenantId", "bottle"]))
                                : _createCommentVNode("", true)
                        ])
                    ], 4))
                    : _createCommentVNode("", true),
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", {
                            class: "spinner-grow text-primary mb-3",
                            role: "status",
                            style: { "width": "3rem", "height": "3rem" }
                        }, [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                        ], -1)),
                        _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(t)('Auswahl wird geladen')), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal
                }, {
                    default: _withCtx(() => [
                        (detailsLid.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                _createElementVNode("div", _hoisted_67, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h3", _hoisted_68, _toDisplayString(detailsLid.value.name), 1),
                                        _createElementVNode("div", {
                                            innerHTML: detailsLid.value.description,
                                            class: "mb-5"
                                        }, null, 8, _hoisted_69)
                                    ]),
                                    _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("div", _hoisted_71, [
                                            _createElementVNode("img", {
                                                src: detailsLid.value.image,
                                                class: "img-fluid rounded",
                                                style: { "max-height": "200px", "max-width": "200px" }
                                            }, null, 8, _hoisted_72)
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
